
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabserviceinaurangabad() {



const cardData = {
  keyword: 'Cab Service in Aurangabad MIDC (Sambhaji Nagar MIDC)',
  heading: 'eTravo: Efficient and Dependable Corporate Cab Services in Aurangabad MIDC (Sambhaji Nagar MIDC)',
  headingDescription: 'eTravo offers professional corporate cab services in Aurangabad MIDC (Sambhaji Nagar MIDC), a key industrial hub known for its manufacturing units, automotive plants, and pharmaceutical companies. Our services are tailored to meet the transportation needs of large factories, SMEs, and office parks operating across the industrial zones of Aurangabad. From daily employee shuttles and shift-based logistics to executive car rentals, we ensure every ride is timely, safe, and comfortable. With well-trained drivers, GPS tracking, and responsive support, eTravo helps businesses improve workforce mobility and operational efficiency throughout the region.',

  top: 'Major Business Hubs in Aurangabad MIDC (Sambhaji Nagar MIDC) Served by eTravo',
  topPlaces: [
    {
      title: 'Waluj MIDC',
      description: 'One of the largest industrial zones in Maharashtra, housing companies like Bajaj Auto, Siemens, and Varroc. eTravo provides large-scale employee transport with multi-stop shuttle cabs and executive vehicles for site visits and inspections.'
    },
    {
      title: 'Shendra MIDC',
      description: 'An emerging industrial growth center under the DMIC project, hosting automotive and electronics industries. Our corporate cab services support daily commutes, plant shift transport, and high-level business travel.'
    },
    {
      title: 'Chikalthana MIDC',
      description: 'Home to pharmaceutical units and engineering firms, Chikalthana is served by eTravo’s scheduled staff pickups, drop-offs, and tailored vehicle plans. Safety and punctuality are our top priorities here.'
    },
    {
      title: 'Five Star Industrial Area',
      description: 'High-investment industrial zone with several export-oriented units. eTravo provides clean, air-conditioned cabs for executives, investors, and international delegates, ensuring a smooth and professional experience.'
    },
    {
      title: 'Auric City (Aurangabad Industrial City)',
      description: 'A smart industrial city near Shendra offering state-of-the-art infrastructure. eTravo helps companies based here with tech-enabled fleet management and centralized transport coordination.'
    }
  ],

  services: [
    {
      name: 'Aurangabad MIDC Corporate Cab Rentals',
      description: 'Our corporate cab rental service in Aurangabad MIDC provides customized, scalable transport for businesses of all sizes. Whether you need a fleet for shift-based operations or occasional executive travel, we’ve got flexible rental models that cover it all. Choose from hatchbacks, sedans, or MUVs depending on your needs. All vehicles come with verified drivers and are maintained for optimal performance. Contracts are available on daily, weekly, or monthly basis.'
    },
    {
      name: 'Employee Transport Cab Aurangabad MIDC',
      description: 'Designed for daily staff commute across Aurangabad MIDC zones, our employee cab service includes fixed routes, rides, and real-time tracking. We help HR teams manage shift-based staff logistics smoothly. Drivers follow strict time discipline to reduce delays. Our service is trusted by manufacturing plants, IT firms, and export houses alike. Optional SMS alerts and attendance integrations are available.'
    },
    {
      name: 'Business Cab Services Aurangabad MIDC',
      description: 'Ideal for on-the-go professionals, business meetings, or vendor visits, this service provides swift, reliable cab support. You can book cabs on an hourly basis or for intercity business travel. We ensure availability even during peak hours or short notice. Vehicles are clean, air-conditioned, and equipped with phone chargers and basic amenities. Suitable for both SMEs and large-scale enterprises.'
    },
    {
      name: 'Corporate Staff Cabs Aurangabad MIDC',
      description: 'We offer structured cab services for employee groups working in factories, call centers, or logistics facilities. With options like multi-point pick-ups and shift-specific routing, your teams arrive on time, every time. Our cab network covers even remote areas near Waluj and Chikalthana. Fleet performance and driver behavior are regularly audited for safety. This service reduces absenteeism and enhances punctuality.'
    },
    {
      name: 'Reliable Corporate Cab Service Aurangabad MIDC',
      description: 'Reliability is the hallmark of our service. With vehicle health checks, driver background verifications, and backup vehicle readiness, you can trust eTravo to deliver even under pressure. We maintain over 95% on-time performance. Support teams monitor every ride and resolve issues proactively. From small firms to global OEMs, our reliability has earned repeat business and long-term contracts.'
    },
    {
      name: 'AC Corporate Cabs Aurangabad MIDC',
      description: 'All eTravo cabs come air-conditioned, sanitized, and ergonomically equipped for a relaxing ride. Especially important during Aurangabad’s hot summers, these AC cabs help employees and executives travel comfortably. Drivers maintain interior hygiene and offer bottled water if requested. Our AC cab services are preferred for long commutes and client travel. Comfort meets professionalism in every ride.'
    },
    {
      name: 'Staff Pickup and Drop Cab Aurangabad MIDC',
      description: 'Running multiple shifts? Our staff pickup and drop service handles even complex routing needs. Routes are optimized for minimal travel time and cost savings. We provide daily dashboards to HR/admin teams showing staff movement. Vehicle changes are handled quickly if needed. Safety protocols include driver ID verification, route GPS, and panic button functionality.'
    },
    {
      name: 'Affordable Business Cab Rentals Aurangabad MIDC',
      description: 'Small and medium businesses benefit from our affordable rental plans that don’t compromise on quality. You can choose budget-friendly cars with fuel-efficient routing for daily business errands. Transparent billing and flexible packages help you stay within budget. Discounts available for long-term contracts. Ideal for suppliers, SMEs, and distribution partners operating in the MIDC zones.'
    },
    {
      name: 'Executive Cab Services Aurangabad MIDC',
      description: 'Offer a premium experience to your executives, consultants, or guests with our high-end cab services. Vehicles include sedans, SUVs, and luxury cars driven by uniformed chauffeurs. Services are designed for airport transfers, plant visits, or cross-city travel. Optional amenities include WiFi, refreshments, and newspapers. Impress clients and maintain professional standards effortlessly.'
    },
    {
      name: 'Monthly Corporate Cab Rentals Aurangabad MIDC',
      description: 'Our monthly cab rental plans are perfect for ongoing staff transport with predictable routes. You get fixed pricing, daily logs, and guaranteed vehicle availability. These plans simplify budgeting and reduce last-minute logistics chaos. Ideal for HR teams handling multi-location staff. Choose single or multiple vehicles with full maintenance included.'
    },
    {
      name: 'Industrial Area Employee Transport Aurangabad MIDC',
      description: 'From shop floor workers to office staff, our industrial transport solutions ensure smooth daily commutes across all zones in Aurangabad MIDC. Routes are custom-designed to pick up maximum employees with minimal delay. The service is scalable for sudden manpower increases. Emergency standby vehicles can also be provided. Ensures better productivity and reduced HR overhead.'
    },
    {
      name: 'Corporate Client Cabs Aurangabad MIDC',
      description: 'When your clients visit, ensure they travel in comfort and style. Our client cab services include airport pickups, hotel-to-office rides, and full-day rentals. Drivers are trained in hospitality and local knowledge. Your guests receive a polished brand experience. Suitable for plant tours, investor visits, or VIP meetings.'
    },
    {
      name: 'Business Meeting Cabs Aurangabad MIDC',
      description: 'Never be late to a meeting again with eTravo’s fast-access meeting cabs. Book by the hour or for round trips between offices, hotels, or industrial units. Drivers are punctual and well-versed in local routes. A must-have for sales teams, site supervisors, and procurement managers. Avoid delays and focus on your agenda.'
    },
    {
      name: 'Aurangabad Industrial Area Cab Hire',
      description: 'Need a cab for an event, audit, or visiting team? Our industrial cab hire offers flexible booking without long-term contracts. Choose from small hatchbacks to large people movers. Ideal for guest logistics, team outings, or plant setup support. Competitive pricing and excellent availability guaranteed.'
    },
    {
      name: 'Corporate Shuttle Cabs Aurangabad MIDC',
      description: 'We offer scheduled shuttle services connecting residential areas with Aurangabad MIDC hubs. Ideal for large companies wanting to reduce transport costs while enhancing employee convenience. Rides are organized with fixed pickup points and time slots. Live tracking and driver attendance reports included.'
    }
  ],

  tableData: [
    ['Aurangabad MIDC Corporate Cab Rentals', 'Employee Transport Cab Aurangabad MIDC'],
    ['Business Cab Services Aurangabad MIDC', 'Corporate Staff Cabs Aurangabad MIDC'],
    ['Reliable Corporate Cab Service Aurangabad MIDC', 'AC Corporate Cabs Aurangabad MIDC'],
    ['Staff Pickup and Drop Cab Aurangabad MIDC', 'Affordable Business Cab Rentals Aurangabad MIDC'],
    ['Executive Cab Services Aurangabad MIDC', 'Monthly Corporate Cab Rentals Aurangabad MIDC'],
    ['Industrial Area Employee Transport Aurangabad MIDC', 'Corporate Client Cabs Aurangabad MIDC'],
    ['Business Meeting Cabs Aurangabad MIDC', 'Aurangabad Industrial Area Cab Hire'],
    ['Corporate Shuttle Cabs Aurangabad MIDC', '']
  ],


"whychoose": [
  {
    "WhyChooseheading": "Customized Corporate Cab Services for Aurangabad (Sambhaji Nagar) MIDC",
    "WhyChoosedescription": "eTravo offers specialized and dependable corporate cab services tailored for the industrial and manufacturing zones of Aurangabad MIDC (also known as Sambhaji Nagar MIDC). With a deep understanding of the commuting challenges in this rapidly developing industrial region, we provide timely, safe, and efficient transportation solutions for employees and business executives. Our services help enhance workforce reliability, reduce late arrivals, and support smoother daily operations for companies in sectors like pharmaceuticals, auto manufacturing, and engineering."
  },
  {
    "WhyChooseheading": "Fleet Versatility for All Corporate Travel Needs",
    "WhyChoosedescription": "Our diverse vehicle fleet—comprising sedans, SUVs, and MUVs—caters to a variety of corporate use cases including shift-based employee transportation, VIP movement, and inter-plant transfers. Each vehicle is clean, well-maintained, and fitted with comfort and safety features to ensure a premium travel experience."
  },
  {
    "WhyChooseheading": "Local Drivers with Route Familiarity Across Aurangabad MIDC",
    "WhyChoosedescription": "Our experienced drivers are well-acquainted with the layout of Aurangabad MIDC and surrounding zones like Waluj, Chikalthana, and Shendra. Their local expertise ensures that your employees reach their destinations safely and on time—even during peak traffic hours or route diversions."
  },
  {
    "WhyChooseheading": "Flexible Booking & Scheduling for Industrial Workflows",
    "WhyChoosedescription": "We support flexible transportation plans including recurring shifts, multiple pickup points, long-term cab rentals, and on-demand rides. Our solutions are ideal for companies operating in multiple shifts or with fluctuating employee rosters."
  },
  {
    "WhyChooseheading": "GPS Tracking and Live Ride Monitoring",
    "WhyChoosedescription": "All cabs are GPS-enabled, allowing real-time tracking of employee rides. This feature boosts safety, allows employers to monitor ride status, and enables quick response in case of delays or route changes."
  },
  {
    "WhyChooseheading": "Transparent Billing and Automated Invoices",
    "WhyChoosedescription": "We provide accurate, transparent billing with detailed invoices covering trip logs, fares, and additional charges. This simplifies expense management and makes audits and reimbursements easier for corporate finance teams."
  },
  {
    "WhyChooseheading": "Strict Hygiene and Safety Compliance",
    "WhyChoosedescription": "Every vehicle in our fleet adheres to strict hygiene protocols including daily sanitization, regular maintenance, and health-verified drivers. This ensures a secure and sanitized environment for your employees, especially during health-sensitive times."
  },
  {
    "WhyChooseheading": "Dedicated Account Managers for Seamless Corporate Support",
    "WhyChoosedescription": "We assign a dedicated account manager to each corporate client to assist with service customization, bookings, issue resolution, and reporting—ensuring consistent and responsive support throughout your engagement with us."
  }
]
}

const faqData = [
  [
    {
      question: "Which zones in Aurangabad MIDC do you cover?",
      answer: "We provide service across all major industrial belts including Shendra, Waluj, Chikalthana, and Paithan Road MIDC zones in Aurangabad (Sambhaji Nagar)."
    },
    {
      question: "Can we set up recurring shift-based transportation?",
      answer: "Yes, we offer scheduled and recurring rides tailored for shift operations common in manufacturing and industrial setups."
    },
    {
      question: "Do you provide monthly billing with detailed usage reports?",
      answer: "Absolutely. We issue monthly invoices with complete ride history, usage breakdown, and GST-compliant documentation."
    },
    {
      question: "Are your drivers trained in corporate etiquette and safety practices?",
      answer: "Yes, our drivers are trained to follow professional conduct, safety regulations, and hygiene protocols at all times."
    },
    {
      question: "How do you ensure safety for our employees during travel?",
      answer: "We use real-time GPS tracking, maintain vehicles regularly, and implement driver background checks and health screening."
    },
    {
      question: "Is there dedicated customer support for businesses in Aurangabad MIDC?",
      answer: "Yes, each client is assigned a dedicated account manager for personalized support, reports, and service optimization."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Saurabh Deshmukh",
    designation: "Plant Head, Zenith Auto Components",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo has made our employee transport in Aurangabad MIDC smooth and stress-free. Timely pickups and professional service have improved our daily operations.”"
  },
  {
    name: "Ms. Prajakta Jadhav",
    designation: "HR Manager, MedSol Pharmaceuticals",
    rating: [1, 1, 1, 1, 1],
    text: "“Excellent coordination and hygiene standards. eTravo has helped us streamline our shift-based transportation at Waluj MIDC.”"
  }
];




























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Aurangabad MIDC (Sambhaji Nagar MIDC)",
  "image": "https://www.etravo.in/images/keyword/cab-service-aurangabad-midc.jpg",
  "description": "Affordable and reliable corporate cab service in Aurangabad MIDC (Sambhaji Nagar MIDC) for employee transport, business meetings, and industrial area commutes. Book AC corporate cabs with professional drivers at eTravo.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.85",
    "ratingCount": "7685"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1399",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-aurangabad-midc"
  }
};






    return (
        <div>

<Helmet>
  <title>Cab Service in Aurangabad MIDC | Corporate & Staff Transport | eTravo</title>
  <meta 
    name="description" 
    content="Hire cab service in Aurangabad MIDC (Sambhaji Nagar MIDC) for corporate staff transport, business meetings, and industrial commutes. Reliable AC corporate cabs by eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/66.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceinaurangabad;